module.exports = __webpack_public_path__ + "img/1_uk.4c7202b3.svg";